"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapQueryToString = mapQueryToString;
exports.mapInterpretationToString = mapInterpretationToString;
exports.isSubQueryOf = isSubQueryOf;
exports.mapEventsToAttachments = mapEventsToAttachments;
exports.groupQueries = groupQueries;
exports.isEventOfQuery = isEventOfQuery;
exports.findLastEventByQuery = findLastEventByQuery;
exports.findEventsByQueries = findEventsByQueries;
exports.findEventsByQuery = findEventsByQuery;
const ramda_1 = require("ramda");
const attachments_1 = require("../attachments");
function mapQueryToString({ interpretation: i, tags: ts = [] }) {
    let result = "";
    if (i !== undefined) {
        result += mapInterpretationToString(i);
    }
    if (ts.length !== 0) {
        result += `>>${ts.slice().map(mapTagToString).sort().join(`,`)}`;
    }
    return encodeURIComponent(result);
}
function mapInterpretationToString(i) {
    return `${i.vocab}|${i.code}`;
}
function mapTagToString(t) {
    let k = mapInterpretationToString(t);
    if (t.source !== undefined) {
        k = `${k}::${t.source}`;
    }
    return k;
}
function isSubQueryOf(q1, q2) {
    return ((q1.interpretation === undefined ||
        (0, ramda_1.equals)(q1.interpretation, q2.interpretation)) &&
        (q1.tags || []).every(t1 => (q2.tags || []).some(t2 => (0, ramda_1.equals)(t1, t2))));
}
function mapEventsToAttachments(events) {
    const list = (Array.isArray(events) ? events : [events]).flatMap(({ timestamp, attachments }) => (attachments || []).map(filename => ({ timestamp, filename })));
    return (0, attachments_1.uniqueAttachmentList)(list);
}
function groupQueries(qs) {
    const m1 = mapQueriesByLimit(qs);
    return Object.values(m1)
        .map(mapQueriesByInterpretation)
        .flatMap(createQueryGroups);
}
function mapQueriesByLimit(qs) {
    const m = {};
    for (const q of qs) {
        const { limit: k = 1 } = q;
        if (m[k] === undefined) {
            m[k] = [q];
        }
        else {
            m[k].push(q);
        }
    }
    return m;
}
function mapQueriesByInterpretation(qs) {
    const m = {};
    for (const q of qs) {
        const k = q.interpretation === undefined
            ? ""
            : mapInterpretationToString(q.interpretation);
        if (m[k] === undefined) {
            m[k] = [q];
        }
        else {
            m[k].push(q);
        }
    }
    return m;
}
function createQueryGroups(m) {
    const vs = Object.values(m);
    let l = 0;
    for (const qs of vs) {
        l = Math.max(l, qs.length);
    }
    const gs = [];
    for (let i = 0; i < l; i++) {
        gs[i] = [];
    }
    for (const qs of vs) {
        for (let i = 0; i < qs.length; i++) {
            gs[i].push(qs[i]);
        }
    }
    return gs;
}
function isEventOfQuery(query, event) {
    if (query.interpretation !== undefined &&
        !isSameEventQueryInterpretation(query.interpretation, event.interpretation)) {
        return false;
    }
    if (query.tags !== undefined &&
        !query.tags.every(tagA => event.tagDetails.some(tagB => isSameEventQueryTag(tagA, mapEventTagToEventQueryTag(tagB))))) {
        return false;
    }
    return true;
}
function isSameEventQueryInterpretation(a, b) {
    return a.vocab === b.vocab && a.code === b.code;
}
function isSameEventQueryTag(a, b) {
    return a.vocab === b.vocab && a.code === b.code && a.source === b.source;
}
function mapEventTagToEventQueryTag({ source, ...tag }) {
    if (source === null) {
        return tag;
    }
    return { ...tag, source };
}
function findLastEventByQuery(events, query) {
    const code = mapQueryToString(query);
    return events[code]?.events[0];
}
function findEventsByQueries(events, queries) {
    return queries.map(query => findLastEventByQuery(events, query));
}
function findEventsByQuery(events, query) {
    const code = mapQueryToString(query);
    return events[code]?.events ?? [];
}
